export const normalizeYoutubeUrl = (url: string) => {
  try {
    const parsed = new URL(url);

    if (parsed.hostname.includes("youtu.be")) {
      const videoId = parsed.pathname.replace("/", "");
      return videoId ? `https://www.youtube.com/watch?v=${videoId}` : url;
    }

    if (parsed.hostname.includes("youtube.com")) {
      if (parsed.pathname.startsWith("/embed/")) {
        const videoId = parsed.pathname.split("/embed/")[1]?.split("/")[0];
        return videoId ? `https://www.youtube.com/watch?v=${videoId}` : url;
      }

      if (parsed.pathname.startsWith("/shorts/")) {
        const videoId = parsed.pathname.split("/shorts/")[1]?.split("/")[0];
        return videoId ? `https://www.youtube.com/watch?v=${videoId}` : url;
      }
    }

    return url;
  } catch {
    return url;
  }
};
